import { createContext, useReducer } from "react";
import MenuReducer from "./menuReducer";

const INITIAL_STATE = {
	mobileMenu: false,
};

export const MenuContext = createContext(INITIAL_STATE);

export const MenuContextProvider = ({ children }) => {
	const [state, dispatch] = useReducer(MenuReducer, INITIAL_STATE);

	return (
		<MenuContext.Provider value={{ mobileMenu: state.mobileMenu, dispatch }}>
			{children}
		</MenuContext.Provider>
	);
};
